import { render, staticRenderFns } from "./EnderecoUnidadesConsumidorasFields.vue?vue&type=template&id=90e52fd2&scoped=true&"
import script from "./EnderecoUnidadesConsumidorasFields.vue?vue&type=script&lang=js&"
export * from "./EnderecoUnidadesConsumidorasFields.vue?vue&type=script&lang=js&"
import style0 from "./EnderecoUnidadesConsumidorasFields.vue?vue&type=style&index=0&id=90e52fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e52fd2",
  null
  
)

export default component.exports